export { default as Text } from './Text';
export { Typography } from './Typography';
export type { TextProps, TextVariant } from './types';
